import { Component, Input, OnInit, inject } from '@angular/core';
import {
  CenterOnLocation,
  GeoCalculationService,
  GeoCalculationServiceInjector,
} from '@next/arable-lib/geo';
import { ShouldDisplaySoilAnalysisCharacteristicAbbreviation } from '@next/arable-lib/shared';
import { Store } from '@ngrx/store';
import { SiteState } from 'src/app/shared/models';

import { SoilAnalysisTitleHelper } from 'src/app/soil-analysis/helpers/SoilAnalysisTitleHelper';

import { SoilAnalysis } from '../../../soil-analysis/models/soil-analysis.model';
import * as SoilAnalysisActions from '../../../soil-analysis/store/soil-analysis.actions';

@Component({
  selector: 'app-soil-analysis-detail',
  templateUrl: './soil-analysis-detail.component.html',
  styleUrls: ['./soil-analysis-detail.component.scss'],
  standalone: false,
})
export class SoilAnalysisDetailComponent implements OnInit {
  private readonly store = inject<Store<SiteState>>(Store);
  private readonly geoCalculationService = inject<GeoCalculationService>(
    GeoCalculationServiceInjector,
  );

  @Input() soilAnalysis: SoilAnalysis;
  @Input() showDescription = true;

  shouldDisplaySoilAnalysisCharacteristicAbbreviation =
    ShouldDisplaySoilAnalysisCharacteristicAbbreviation;

  displayedColumns: string[] = ['designation', 'value'];

  ngOnInit(): void {
    this.showTargetValuesColumn();
    this.centerOnField();
  }

  centerOnField(): void {
    const coords = this.soilAnalysis.borderData?.geometry?.coordinates[0];

    if (!coords) {
      return;
    }

    const boundingBox = this.geoCalculationService.getBoundingBoxWithPadding(coords, 0.3);

    if (boundingBox !== null) {
      this.store.dispatch(new CenterOnLocation([boundingBox[0], boundingBox[1]]));
    }
  }

  editSoilAnalysis(soilAnalysis: SoilAnalysis) {
    this.store.dispatch(SoilAnalysisActions.initEditManualSoilAnalysis({ id: soilAnalysis.id }));
  }

  isWithinTargetValues = (value: number, targetValues: { minimum: number; maximum: number }) =>
    targetValues.minimum <= value && value <= (targetValues.maximum || Number.MAX_SAFE_INTEGER);

  targetValuesHasBothMinAndMax = (targetValues: { minimum: number; maximum: number }) =>
    targetValues.minimum * targetValues.maximum !== 0;

  getSoilAnalysisTitle(soilAnalysis: SoilAnalysis): string {
    return SoilAnalysisTitleHelper.getSoilAnalysisTitle(soilAnalysis);
  }

  private showTargetValuesColumn() {
    const targetValuesSampledCharacteristic = this.soilAnalysis.sampledCharacteristics.some(
      (sampledCharacteristic) => sampledCharacteristic.targetValues,
    );
    if (targetValuesSampledCharacteristic) {
      this.displayedColumns.push('targetValues');
    }
  }
}
